import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import PropertyDetail from "@/pages/PropertyDetail";
import LegalPage from "@/pages/LegalPage";
import ChiSiamo from "@/pages/ChiSiamo";

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/strutture/:slug" element={<PropertyDetail />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/cookie-policy" element={<LegalPage type="cookie" />} />
            <Route path="/termini" element={<LegalPage type="termini" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </div>
  );
}

export default App;
